import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Socket from '../../../connection/socket';


interface Props {
	socket: Socket | null;
}

export default function Templates(props: Props) {
	const host = useSelector((state: any) => state.SessionReducer.host);

	const { socket } = props;

	return (
		<>
			templates
		</>

	)
}